import { useState } from 'react';
import './EDH.css';

const API_URL = 'https://nxnhzwo6bjmzf5wo6verng4hjy0zswuu.lambda-url.us-east-1.on.aws/';
const DEMO_PORTAL = 'https://edh-demo.firstgradient.com/demo-login';

export default function EDH() {
  const [accessGranted, setAccessGranted] = useState(false);
  const [sending, setSending] = useState(false);

  const handleDemoRequest = async (e) => {
    e.preventDefault();
    setSending(true);
    const form = e.target;
    const data = { name: form.name.value, email: form.email.value, phone: form.phone.value, message: `[DEMO REQUEST] ${form.name.value} (${form.email.value}, ${form.phone.value}) requested EDH demo access.` };
    try {
      await fetch(API_URL, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(data) });
    } catch {}
    setSending(false);
    setAccessGranted(true);
  };

  return (
    <div className="page edh-page">
      <h1>Engineering Development Hub (EDH)</h1>
      <p className="edh-intro">
        We deploy and manage{' '}
        <a href="https://github.com/awslabs/engineering-development-hub" target="_blank" rel="noopener noreferrer">
          AWS Engineering Development Hub
        </a>{' '}
        — a complete HPC environment for running engineering workloads at scale on AWS.
      </p>

      <section className="edh-features">
        <h2>Platform Capabilities</h2>
        <div className="feature-grid">
          <div className="feature-card">
            <h3>Web Portal</h3>
            <p>Intuitive web interface for job submission, monitoring, file management, and user administration.</p>
          </div>
          <div className="feature-card">
            <h3>Virtual Desktops</h3>
            <p>Linux and Windows desktops with optional GPU acceleration for CAD/CAE visualization via Amazon DCV.</p>
          </div>
          <div className="feature-card">
            <h3>Job Scheduling</h3>
            <p>Support for OpenPBS, Slurm, LSF, and Kubernetes with automatic instance provisioning.</p>
          </div>
          <div className="feature-card">
            <h3>Cost Controls</h3>
            <p>Built-in budget management per project/queue with Spot instance integration and cost allocation tags.</p>
          </div>
          <div className="feature-card">
            <h3>Storage Integration</h3>
            <p>EFS, FSx for Lustre, FSx for NetApp ONTAP, and local NVMe — matched to your workload I/O profile.</p>
          </div>
          <div className="feature-card">
            <h3>Security & SSO</h3>
            <p>LDAP/Active Directory integration, Cognito SSO, encryption everywhere, and scoped IAM policies.</p>
          </div>
        </div>
      </section>

      <section className="edh-demo">
        <h2>Live Demo Environment</h2>
        {!accessGranted ? (
          <>
            <p>Experience EDH firsthand. Fill out the form below to get instant read-only access to our live demo cluster.</p>
            <form className="demo-form" onSubmit={handleDemoRequest}>
              <input name="name" type="text" placeholder="Full Name" required />
              <input name="email" type="email" placeholder="Work Email" required />
              <input name="phone" type="tel" placeholder="Phone Number" required />
              <button type="submit" className="btn-primary" disabled={sending}>
                {sending ? 'Processing...' : 'Access Demo Portal'}
              </button>
            </form>
          </>
        ) : (
          <div className="demo-access">
            <p className="access-granted">✓ Access granted</p>
            <p>Your read-only demo session is ready. Click below to enter the EDH portal directly — no login required. Session expires in 10 minutes.</p>
            <a href={DEMO_PORTAL} target="_blank" rel="noopener noreferrer" className="btn-primary">Enter Demo Portal →</a>
          </div>
        )}
      </section>

      <section className="edh-services">
        <h2>What We Deliver</h2>
        <ul>
          <li>Full EDH deployment tailored to your compute and storage requirements</li>
          <li>Scheduler configuration (PBS, Slurm, or LSF) with custom queue policies</li>
          <li>Active Directory or LDAP integration for user management</li>
          <li>Custom AMI builds optimized for your simulation software</li>
          <li>Budget guardrails and cost allocation by team/project</li>
          <li>Ongoing operations support and cluster upgrades</li>
        </ul>
      </section>
    </div>
  );
}
